interface ChevronDownIconProps {
  size?: number;
  color?: string;
  className?: string;
}

const ChevronDownIcon = ({ size = 16, color = "#243B6B", className }: ChevronDownIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
  >
    <path
      d="M3.5 6L8 10.5L12.5 6"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChevronDownIcon;
